import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "cc346692-a52c-4dd7-9576-a8e7bbaba9b4",
  publicId: "20",
  name: "Closed box system",
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01, task02, task03],
  difficulty: 3,
};

export default lesson;
